var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"100vh"}},[_c('PublicHeaderNew'),_vm._v(" "),_c('div',{attrs:{"id":"registration-block"}},[_c('div',{attrs:{"id":"form-wrapper"}},[_c('nuxt')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }